var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHypertension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08 4.70215L2 16.6421",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1103 4.73145L12.0303 16.7414",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07957 4.70178C2.20957 7.21178 11.6996 7.21178 12.1096 4.73178C12.1496 4.52178 7.40957 1.24178 2.47957 4.29178C2.21957 4.45178 2.06957 4.62178 2.07957 4.70178Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.6416C2 19.0916 12.03 19.1816 12.03 16.7316",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08984 6.55176V18.4918",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92969 18.7615C8.92969 18.7615 10.3997 20.4315 12.8097 20.5215C15.5397 20.6215 17.6797 18.5515 17.6797 15.9315V9.2715L15.2997 6.9215C13.8397 5.4815 15.4797 3.0815 17.3397 3.9315C17.5297 4.0215 17.7397 4.1315 17.9497 4.2715C19.4197 3.2515 21.2197 4.1815 21.2797 5.7515C21.3097 6.5315 20.8297 7.2415 20.1697 7.6515L17.7397 9.1415",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHypertension);
export default __webpack_public_path__ + "static/media/Hypertension.659b885ccea6da33ac7225cc2c2f8014.svg";
export { ForwardRef as ReactComponent };